import React, { useCallback } from 'react';

import { DropdownItem } from '@atlaskit/dropdown-menu';
import { useIntl } from '@atlassian/jira-intl';
import { useDispatch } from '@atlassian/jira-react-redux/src/index.tsx';
import { scrollToPinnedComment } from '@atlassian/jira-issue-view-store/src/actions/issue-scroll-actions.tsx';
import {
	type ScrollTargetType,
	SCROLL_TARGET_TYPES,
} from '@atlassian/jira-issue-scroll/src/services/types.tsx';
import { useIssueScroll } from '@atlassian/jira-issue-scroll/src/services/main.tsx';
import messages from '../../messages.tsx';
import { useCommentContext } from '../CommentContextProvider.tsx';

const ScrollToCommentAction = ({
	handleDropdownClick,
}: {
	handleDropdownClick: (eventName: string) => void;
}) => {
	const { formatMessage } = useIntl();
	const { commentId } = useCommentContext();
	const dispatch = useDispatch();
	const [, { setScrollTarget }] = useIssueScroll();

	const scrollToComment = useCallback(() => {
		handleDropdownClick('meatballMenuScrollToCommentButton');
		const setAndScrollToTarget = (
			scrollTargetType: ScrollTargetType,
			scrollToTargetAction: () => void,
		) => {
			setScrollTarget({
				type: scrollTargetType,
				id: commentId,
			});
			scrollToTargetAction();
		};
		setAndScrollToTarget(SCROLL_TARGET_TYPES.COMMENT, () => dispatch(scrollToPinnedComment()));
	}, [commentId, handleDropdownClick, setScrollTarget, dispatch]);

	return (
		<DropdownItem key="scrollToComment" onClick={scrollToComment}>
			{formatMessage(messages.scrollToComment)}
		</DropdownItem>
	);
};

export default ScrollToCommentAction;
